/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export const getLocalUrl = (serverUrl?: string): string => {
	const fallbackUrl = serverUrl ?? process.env.NEXT_PUBLIC_EPIC_SERVER_URL;
	return `${process.env.HOSTNAME ? `http://${process.env.HOSTNAME}:3000` : fallbackUrl}`;
};
